(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-shop-the-moment"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-moment-shop')) {
    customElements.define('cp-moment-shop', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.addEventListener('click', (event) => {
          const close = event.target.closest('.cp-moment-shop__close');
          if (!close) return;
          const detail = close.closest('details');
          detail.open = false;
          detail.querySelector('summary').focus();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const open = this.querySelector('details[open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); }
        }, options);
        document.addEventListener('click', (event) => {
          this.querySelectorAll('details[open]').forEach((detail) => {
            if (!detail.contains(event.target)) detail.open = false;
          });
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
